/**
 * Authentication API Module
 * Handles all authentication-related API calls
 */

import apiClient, { extractData } from '../api-client';

export const authApi = {
  /**
   * Bước 1 đăng nhập: kiểm mật khẩu. CHƯA trả token thật — chỉ trả vé tạm
   * (hết hạn 5 phút) để đổi lấy token ở bước nhập mã 2FA.
   * @param {Object} credentials - Login credentials
   * @param {string} credentials.username - Username or email
   * @param {string} credentials.password - Password
   * @returns {Promise<{mfa_token: string, setup_required: boolean}>}
   */
  login(credentials) {
    return apiClient.post('/auth/login', credentials).then(extractData);
  },

  /** Lần đầu: { secret, otpauth_uri } để vẽ QR */
  twoFactorSetup(mfaToken) {
    return apiClient.post('/auth/2fa/setup', { mfa_token: mfaToken }).then(extractData);
  },

  /** Bước 2: mã 6 số → { access_token, refresh_token } */
  twoFactorVerify(mfaToken, code) {
    return apiClient.post('/auth/2fa/verify', { mfa_token: mfaToken, code }).then(extractData);
  },

  /**
   * Đổi vé SSO của CMS tổng lấy phiên "Super admin tổng" (1 giờ, KHÔNG có refresh token).
   * @param {string} ve - Vé lấy từ `#ve=...` của link tổng mở
   * @returns {Promise<Object>} Token response, `refresh_token` rỗng
   */
  centralSso(ve) {
    return apiClient.post('/auth/central-sso', { ve }).then(extractData);
  },

  /**
   * Refresh access token
   * @param {Object} tokens - Token object
   * @param {string} tokens.refresh_token - Refresh token
   * @returns {Promise<Object>} New token response
   */
  refresh(tokens) {
    return apiClient.post('/auth/refresh', tokens).then(extractData);
  },

  /**
   * Get current user info
   * @returns {Promise<Object>} User response
   */
  getMe() {
    return apiClient.get('/auth/me').then(extractData);
  },

  /**
   * Ma trận quyền field tiền của user hiện tại
   * (giá sản phẩm/đơn giá dòng hàng/thanh toán/COD/freeship).
   * Dùng để khoá/mở ô nhập ở FE thay vì tự chép lại role set — xem
   * `helpers/orderAccess.js`.
   * @returns {Promise<{can_edit: {
   *   price: boolean,
   *   order_item_price: boolean,
   *   payment: boolean,
   *   cod: boolean,
   *   freeship: boolean
   * }}>}
   */
  getFieldPermissions() {
    return apiClient.get('/auth/me/field-permissions').then(extractData);
  },

  /**
   * Change password
   * @param {Object} passwords - Password object
   * @param {string} passwords.old_password - Current password
   * @param {string} passwords.new_password - New password
   * @returns {Promise<Object>} Response object
   */
  changePassword(passwords) {
    return apiClient.post('/auth/change-password', passwords).then(extractData);
  },

  updateMe(data) {
    return apiClient.put('/auth/me', data).then(extractData);
  }
};
